import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Telescope, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const Header: React.FC = () => {
  const { isAuthenticated, displayName, signOut, signIn } = useAuth();
  const nav = useNavigate();
  const isLanding = useLocation().pathname === '/';

  return (
    <header className="relative z-20 flex items-center justify-between px-6 py-5 md:px-10">
      <Link to="/" className="flex items-center gap-2 group">
        <div className="relative">
          <Telescope className="h-6 w-6 text-nebula-300 group-hover:text-nebula-200 transition-colors" />
          <div className="absolute inset-0 blur-xl bg-nebula-500/40 -z-10" />
        </div>
        <span className="font-display text-lg font-semibold tracking-tight">
          Pancake<span className="text-nebula-300">Stack</span>
        </span>
      </Link>

      <nav className="flex items-center gap-2 md:gap-4">
        {isLanding && (
          <a
            href="/sky/"
            className="text-sm text-white/70 hover:text-white transition-colors px-3 py-1.5"
          >
            Sky map
          </a>
        )}
        {isAuthenticated ? (
          <>
            <button
              onClick={() => nav('/collections')}
              className="text-sm text-white/70 hover:text-white transition-colors px-3 py-1.5"
            >
              Collections
            </button>
            <button
              onClick={() => nav('/jobs')}
              className="text-sm text-white/70 hover:text-white transition-colors px-3 py-1.5"
            >
              Jobs
            </button>
            <span className="hidden md:block text-sm text-white/50">{displayName()}</span>
            <button
              onClick={signOut}
              className="flex items-center gap-1.5 text-sm text-white/70 hover:text-white transition-colors px-3 py-1.5"
            >
              <LogOut className="h-4 w-4" />
              Sign out
            </button>
          </>
        ) : (
          <button
            onClick={signIn}
            className="px-4 py-2 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur text-sm font-medium transition-colors border border-white/10"
          >
            Sign in
          </button>
        )}
      </nav>
    </header>
  );
};

export default Header;
